// Libraries
import { DateTime } from "luxon";

// Utils
import {
  normalizeHealthCard,
  normalizeLastNameForSearch,
} from "Utils/Normalization";

export const mapScannedHealthCardToSearch = (qrJSON = {}) => ({
  scannedCard: qrJSON,
  formValues: {
    lastName: normalizeLastNameForSearch(qrJSON.lastName),
    healthCardNumber: qrJSON.phin,
    dateOfBirth: DateTime.fromFormat(qrJSON.dob, "yyyy-MM-dd"),
  },
});

export const defaultSearchValues = {
  lastName: "",
  healthCardNumber: "",
  dateOfBirth: null,
};

export const matchesCurrentSearch = (searchValues, patient) => {
  if (!patient || !searchValues) {
    return false;
  }

  const normalizedLastName = normalizeLastNameForSearch(searchValues.lastName);
  const normalizedHealthCard = normalizeHealthCard(
    searchValues.healthCardNumber
  );
  const searchDob = searchValues.dateOfBirth?.isValid
    ? searchValues.dateOfBirth.toFormat("yyyy-MM-dd")
    : "";

  if (
    normalizedLastName &&
    normalizeLastNameForSearch(patient.lastName) !== normalizedLastName
  ) {
    return false;
  }

  if (
    normalizedHealthCard &&
    normalizeHealthCard(patient.healthCardNumber) !== normalizedHealthCard
  ) {
    return false;
  }

  if (searchDob && patient.dob !== searchDob) {
    return false;
  }

  return true;
};
